module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-05.f26acb4a.jpg";